module.exports = MaterialUI.Divider;